import React from 'react';
import { Icon } from '@iconify/react';
import { AppButton } from '../ui';
import {
  PLANNING_VIEW_CLIENTS,
  PLANNING_VIEW_DISPOS,
} from '../../utils/kkpPlanningViewMode';
import '../../styles/kkp-planning-view-mode.scss';

const VIEW_OPTIONS = [
  {
    value: PLANNING_VIEW_CLIENTS,
    label: 'Clients',
    icon: 'mdi:account-group-outline',
    hint: 'Ventes attribuées à un client',
  },
  {
    value: PLANNING_VIEW_DISPOS,
    label: 'Dispos',
    icon: 'mdi:calendar-blank-outline',
    hint: 'Emplacements libres et options',
  },
];

/**
 * Sélecteur Clients / Dispos pour les plannings de ventes.
 * `onCreate` affiche un CTA « Nouvelle vente » sur la même ligne.
 */
const KkpPlanningViewModeSwitch = ({
  value = PLANNING_VIEW_CLIENTS,
  onChange,
  counts = { clients: 0, dispos: 0 },
  onCreate,
  createLabel = 'Nouvelle vente',
}) => (
  <div className={`kkp-planning-view-toolbar${onCreate ? ' has-create' : ''}`}>
    <div className="kkp-planning-view-switch" role="group" aria-label="Mode d'affichage du planning">
      {VIEW_OPTIONS.map((option) => {
        const isActive = value === option.value;
        const count = option.value === PLANNING_VIEW_CLIENTS
          ? counts.clients
          : counts.dispos;

        return (
          <button
            key={option.value}
            type="button"
            className={`kkp-planning-view-switch__btn${isActive ? ' is-active' : ''}`}
            aria-pressed={isActive}
            title={option.hint}
            onClick={() => onChange?.(option.value)}
          >
            <Icon icon={option.icon} className="kkp-planning-view-switch__icon" aria-hidden />
            <span>{option.label}</span>
            <span className="kkp-planning-view-switch__count">{count}</span>
          </button>
        );
      })}
    </div>

    {onCreate ? (
      <AppButton
        size="sm"
        variant="primary"
        icon="mdi:plus"
        iconWidth={16}
        className="kkp-planning-view-toolbar__create"
        onClick={onCreate}
      >
        {createLabel}
      </AppButton>
    ) : null}
  </div>
);

export default KkpPlanningViewModeSwitch;
